// test1462
(1462 && 0);
